import { Link } from 'react-router-dom';
import styles from './BackButton.module.css';

/**
 * Consistent "Back" affordance, rendered by `Screen` (below) when a screen
 * declares its parent via `backTo`.
 *
 * Deliberately a real `Link` to an explicit parent route, not
 * `navigate(-1)` — the LiftX-wide hierarchy (plan editor → Training Plans,
 * exercise detail → Exercises, etc.) is fixed and known at each call site,
 * so pointing at the real parent route is both simpler and more predictable
 * than replaying browser history, which can land somewhere unexpected when a
 * screen was reached via a direct URL rather than in-app navigation. Still
 * the app's existing router — not a bespoke history stack.
 */
export function BackButton({ to, label }: { to: string; label: string }): React.JSX.Element {
  return (
    <Link to={to} className={`lxBtn lxBtnGhost ${styles.backButton}`}>
      <span className={styles.chevron} aria-hidden="true">
        ‹
      </span>
      {label}
    </Link>
  );
}
